import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { FiCheck } from 'react-icons/fi';
import { FaWhatsapp } from 'react-icons/fa';
import './Packages.css';

const Packages: React.FC = () => {
  const { t } = useTranslation();

  const packages = [
    {
      name: t('packages.starter.name'),
      price: t('packages.starter.price'),
      features: t('packages.starter.features', { returnObjects: true }) as string[],
      cta: t('packages.starter.cta'),
      popular: false
    },
    {
      name: t('packages.professional.name'),
      price: t('packages.professional.price'),
      features: t('packages.professional.features', { returnObjects: true }) as string[],
      cta: t('packages.professional.cta'),
      popular: true,
      popularLabel: t('packages.professional.popular')
    },
    {
      name: t('packages.enterprise.name'),
      price: t('packages.enterprise.price'),
      features: t('packages.enterprise.features', { returnObjects: true }) as string[],
      cta: t('packages.enterprise.cta'),
      popular: false,
      isEnterprise: true
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5 }
    }
  };

  return (
    <section className="packages section marble-bg" id="packages">
      <div className="packages-bg">
        <div className="packages-glow"></div>
      </div>
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <h2 className="section-title">{t('packages.title')}</h2>
          <p className="section-subtitle">{t('packages.subtitle')}</p>
        </motion.div>

        <motion.div 
          className="packages-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {packages.map((pkg, index) => (
            <motion.div 
              key={index}
              className={`package-card ${pkg.popular ? 'popular' : ''} ${pkg.isEnterprise ? 'enterprise' : ''}`}
              variants={itemVariants}
              whileHover={{ y: -10 }}
            >
              {pkg.popular && (
                <div className="popular-badge">{pkg.popularLabel}</div>
              )}
              <div className="package-header">
                <h3 className="package-name">{pkg.name}</h3>
                <div className="package-price">
                  <span className="price">{pkg.price}</span>
                  {!pkg.isEnterprise && <span className="period">{t('packages.monthly')}</span>}
                </div>
              </div>
              <ul className="package-features">
                {pkg.features.map((feature, idx) => (
                  <li key={idx}>
                    <FiCheck className="check-icon" />
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
              <a 
                href="https://wa.me/905337757181" 
                target="_blank"
                rel="noopener noreferrer"
                className={`package-btn ${pkg.popular ? 'btn-primary' : 'btn-secondary'}`}
              >
                <FaWhatsapp />
                {pkg.cta}
              </a>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Packages;
